import { cx } from "../../../styled-system/css";
import { Container } from "../Container";
import { styles } from "./SectionHeadline.style";

export interface SectionHeadlineProps {
  headline: string;
  headlineWrapperStyles?: string;
  isMainHeadline?: boolean;
}

export const SectionHeadline = (props: SectionHeadlineProps) => {
  const { headline, headlineWrapperStyles, isMainHeadline } = props;
  return (
    <div className={cx(styles.divHeadlineWrapper(), headlineWrapperStyles)}>
      <Container noPaddingMobile>
        {isMainHeadline ? (
          <h1 className={styles.headline()}>{headline}</h1>
        ) : (
          <h2 className={styles.headline()}>{headline}</h2>
        )}
      </Container>
    </div>
  );
};
